import { noop, compose } from 'lodash/fp';
import { connect } from 'react-redux';
import { reset, formValueSelector } from 'redux-form';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { CheckboxField, commanderForm, email, InputField, presence, validation } from '@mews-commander/legacy-form';
import { makeOptional } from '@mews-commander/legacy-entities/src/ducks/reservations';
import { FullWidthFieldsContainer } from '@mews-commander/ui';
import { ReceiverSelectValues } from '../enums';
import ReceiverSelectField from './ReceiverSelectField';

const EMAIL_TYPE_NAME = 'emailType';
const CUSTOM_EMAIL_NAME = 'customEmail';
const SEND_EMAIL_NAME = 'sendEmail';
const OptionalForm = ({ showEmailTypeSelect, showCustomEmail }: $TSFixMe) => (
    <FullWidthFieldsContainer>
        <CheckboxField {...sendEmailProps} />
        {showEmailTypeSelect ? <ReceiverSelectField {...emailTypeProps} /> : null}
        {showCustomEmail ? <InputField {...customEmailProps} /> : null}
    </FullWidthFieldsContainer>
);
const emailTypeProps = {
    label: <LocalizedText textKey={TextKey.Email} />,
    name: EMAIL_TYPE_NAME,
};
const customEmailProps = {
    label: <LocalizedText textKey={TextKey.CustomEmail} />,
    name: CUSTOM_EMAIL_NAME,
    required: true,
};
const sendEmailProps = {
    label: <LocalizedText textKey={TextKey.SendQuotationEmail} />,
    name: SEND_EMAIL_NAME,
};
const getConstraints = ({ showCustomEmail, showEmailTypeSelect }: $TSFixMe) => ({
    ...(showEmailTypeSelect ? { [EMAIL_TYPE_NAME]: { presence } } : {}),
    ...(showCustomEmail ? { [CUSTOM_EMAIL_NAME]: { presence, email } } : {}),
});
export default compose(
    connect(
        // @ts-expect-error $TSFixMeError: Property 'form' does not exist on type '{}'.
        (state, { form }) => {
            const formSelector = formValueSelector(form);
            const showEmailTypeSelect = formSelector(state, SEND_EMAIL_NAME);
            return {
                showEmailTypeSelect,
                showCustomEmail:
                    showEmailTypeSelect && formSelector(state, EMAIL_TYPE_NAME) === ReceiverSelectValues.CustomEmail,
            };
        },
        // @ts-expect-error $TSFixMeError: Property 'reservationIds' does not exist on type '{}'.
        (dispatch, { reservationIds, onSuccess = noop, form }) => ({
            // @ts-expect-error $TSFixMeError: Binding element 'customEmail' implicitly has an 'any' type.
            onSubmit: ({ [CUSTOM_EMAIL_NAME]: customEmail, [SEND_EMAIL_NAME]: sendEmail }) =>
                // @ts-expect-error $TSFixMeError: Argument of type 'ThunkAction<Action<any>, void>' is not assignable to parameter of type 'Action<any>'.
                (dispatch(makeOptional({ reservationIds, customEmail, sendEmail })) as $TSFixMe).then(() => {
                    dispatch(reset(form));
                    onSuccess();
                }),
        })
    ),
    commanderForm({
        enableReinitialize: true,
        submitLabel: <LocalizedText textKey={TextKey.Optional} />,
        validate: validation(getConstraints),
    })
)(OptionalForm);
